export const SCHEDULE_FORM_TITLE_CHANGE = "SCHEDULE_FORM_TITLE_CHANGE";
export const SCHEDULE_FORM_DATE_CHANGE = "SCHEDULE_FORM_DATE_CHANGE";
export const SCHEDULE_FORM_TIME_CHANGE = "SCHEDULE_FORM_TIME_CHANGE";
export const SCHEDULE_FORM_LANGUAGE_CHANGE = "SCHEDULE_FORM_LANGUAGE_CHANGE";
export const SCHEDULE_FORM_DESCRIPTION_CHANGE = "SCHEDULE_FORM_DESCRIPTION_CHANGE";
